export async function parseJsonSafely(response) {
    try {
        return await response.json();
    } catch (error) {
        return null;
    }
}

export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
